import Storage from '@/utils/storage'
const state = {
  eventInfo: Storage.get('eventInfo') ? JSON.parse(Storage.get('eventInfo')) : { eventId: '', schedule: '' },
  eventFilter: {
    productIdList: [],
    startTime: '',
    endTime: '',
    eventType: ''
  }
}

const mutations = {
  SET_EVENTINFO (state, data) {
    data.schedule = data.schedule === '' ? 1 : data.schedule
    window.localStorage.setItem('eventInfo', JSON.stringify(data))
    state.eventInfo = data
  },
  SET_EVENT_FILTER (state, filter) {
    state.eventFilter = { ...state.eventFilter, ...filter }
  },
  CLEAR_EVENT_FILTER (state) {
    state.eventFilter = {
      productIdList: [],
      startTime: '',
      endTime: '',
      eventType: ''
    }
  }
}

const actions = {}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
